import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/show_schedule/${container_scheduled_service_id}`
    );
  },
  fetchAgroExporter({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/show_schedule/fetch_agro_exporter/${container_scheduled_service_id}`
    );
  },
  destroy({ container_scheduled_service_id }) {
    return RequesterV1.delete(
      `service_provider/services/container_op/show_schedule/${container_scheduled_service_id}`
    );
  },
};
